import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ErrorList extends Component {
    render() {
        const {list} = this.props

        return (
            <div className="ErrorList">
                {
                    list.map((item, index) => {
                        return <div className="mb-1" key={index}>
                            Template: <strong>{item.item}</strong> <br/>
                            Lỗi: {item.message}
                        </div>
                    })
                }
            </div>
        )
    }
}

ErrorList.propTypes = {
    list: PropTypes.array.isRequired
}

export default ErrorList